import React from 'react';
import { Link } from 'react-router-dom';
import { formatTimeAgo, formatXPUNT } from '../../utils/helpers';
import { 
  FaUsers, FaClock, FaTrophy, FaLock, FaUnlock,
  FaImage, FaCoins, FaTicketAlt 
} from 'react-icons/fa';
import './CompetitionCard.css';

const CompetitionCard = ({ competition }) => {
  const {
    id,
    title,
    description,
    status,
    is_free,
    join_price,
    players_count,
    total_prize_pool,
    prize_pool,
    created_at,
    visibility,
    image_url,
    total_winners,
    // ==================== NEW FIELDS ====================
    total_games,
    games_added,
    is_full,
    reward_claim_open,
    my_reward,
    my_reward_claimed,
  } = competition;

  const getStatusBadge = () => {
    const badges = {
      open: { label: 'Open', className: 'status-open' },
      ended: { label: 'Ended', className: 'status-ended' },
      upcoming: { label: 'Upcoming', className: 'status-upcoming' },
      full: { label: 'Full', className: 'status-full' },
      active: { label: 'Active', className: 'status-open' },
      completed: { label: 'Completed', className: 'status-ended' },
    };
    return badges[status] || badges.open;
  };

  const statusBadge = getStatusBadge();
  const prizeAmount = prize_pool || total_prize_pool || 0;

  // ==================== PROGRESS ====================
  const totalGamesNum = Number(total_games) || 0;
  const gamesAddedNum = Number(games_added) || 0;
  const progressPct = totalGamesNum > 0
    ? Math.min(100, (gamesAddedNum / totalGamesNum) * 100)
    : 0;
  const showProgress = totalGamesNum > 0;

  // ==================== CLAIM ====================
  const showClaimBadge = status === 'completed' && reward_claim_open;

  return (
    <div className="competition-card">
      {/* Competition Image */}
      <div className="competition-card-image">
        {image_url ? (
          <img 
            src={image_url} 
            alt={title} 
            className="competition-image"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
        ) : null}
        <div 
          className="image-placeholder" 
          style={{ display: image_url ? 'none' : 'flex' }}
        >
          <FaTrophy className="placeholder-icon" />
          <span>No Image</span>
        </div>
        
        {/* Overlay badges */}
        <div className="image-overlay">
          <span className={`competition-status ${statusBadge.className}`}>
            {statusBadge.label}
          </span>
          {visibility === 'private' && (
            <span className="competition-private">
              <FaLock /> Private
            </span>
          )}
        </div>
        
        {/* Prize Pool Badge */}
        {prizeAmount > 0 && (
          <div className="prize-pool-badge">
            <FaCoins className="prize-icon" />
            <span>{formatXPUNT(prizeAmount)}</span>
          </div>
        )}
      </div>

      <div className="competition-card-body">
        {/* Header */}
        <div className="competition-card-header">
          <div className="competition-card-meta">
            {visibility === 'public' && (
              <span className="competition-public">
                <FaUnlock /> Public
              </span>
            )}
            {total_winners > 0 && (
              <span className="winners-badge">
                <FaTrophy /> {total_winners} winner{total_winners > 1 ? 's' : ''}
              </span>
            )}
          </div>
          <div className="competition-card-price">
            {is_free ? (
              <span className="free-badge">Free Entry</span>
            ) : (
              <span className="price-badge">{formatXPUNT(join_price)}</span>
            )}
          </div>

            <Link to={`/competitions/${id}`}  className="competition-card-price winners-badge">View</Link>


       
        </div>

        {/* Title & Description */}
        <h3 className="competition-card-title">{title}</h3>
        

        {/* ==================== GAMES PROGRESS ==================== */}
        {showProgress && (
          <div className="comp-games-progress">
            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${progressPct}%` }}
              />
            </div>
            <span className="progress-label">
              {gamesAddedNum} / {totalGamesNum} games
            </span>
          </div>
        )}

        {/* ==================== CLAIM BADGE ==================== */}
        {showClaimBadge && (
          <div className="comp-claim-badge">
            {my_reward_claimed
              ? `✅ Reward claimed`
              : my_reward > 0
                ? `🏆 Reward available — tap to claim`
                : `🏆 Rewards available`}
          </div>
        )}
      </div>

      {/* Footer Stats */}
      <div className="competition-card-footer">
        <div className="competition-card-stats">
          <div className="stat">
            <FaUsers className="stat-icon" />
            <span>{players_count || 0}</span>
          </div>
          <div className="stat">
            <FaTicketAlt className="stat-icon" />
            <span>{is_free ? 'Free' : formatXPUNT(join_price)}</span>
          </div>
          <div className="stat">
            <FaClock className="stat-icon" />
            <span>{formatTimeAgo(created_at)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompetitionCard;